module.exports = __webpack_public_path__ + "img/picture-5.dc219dcf.png";